import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83bbf530")

_pushScopeId("data-v-83bbf530")
const _hoisted_1 = {
  class: "select-category",
  id: "selectCategoryComponentTop"
}
const _hoisted_2 = { class: "select-category-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectCategoryItem = _resolveComponent("SelectCategoryItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryArray, (category) => {
        return (_openBlock(), _createBlock(_component_SelectCategoryItem, {
          class: "select-category-item",
          key: category.index,
          index: category.index,
          categoryName: category.categoryName,
          isSelect: category.isSelect,
          onOnClick: _ctx.selectCategory
        }, null, 8, ["index", "categoryName", "isSelect", "onOnClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})